import React, { Component } from "react";
import ApiConstants from "../../constants/ApiConstants";
import http from "../../http";
import { INPUT_TYPE } from "../../constants/Constant";
import {
    DKLabel,
    DKIcon,
    DKInput,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import { COUNTRY, IN_STATES, US_COUNTIES, US_STATES } from "../../constants/CountryConstant";
import { Countries } from "../add-employee/steps/Employee";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import Utility, { deepClone } from "../../utility/Utility";
import { ZIPCODE_REGEX } from "../../constants/RegexConstants";
import ReactTooltip from "react-tooltip";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { MODULE } from "../user-permissions/PermissionUtils";

class Address extends Component {
    constructor(props) {
        super(props);

        this.USAddressOptions = [];

        this.state = {
            count: 0,
            countryCode: this.props.countryCode,
            addressFields: this.props.addressFields
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.addressFields !== prevState.addressFields) {
            return {
                countryCode: nextProps.countryCode,
                addressFields: nextProps.addressFields
            };
        }

        return null;
    }

    getSelectLabel(v, o) {
        let value = v;

        const index = o.findIndex(i => i.value === v);
        if (index !== -1) {
            value = o[index].label;
        }

        return value;
    }

    getSelectValue(v, o) {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }

    getAutocompleteData(field) {
        if (this.state.countryCode === COUNTRY.US && field.id === "addressLine1") {
            const address = this.getUSAddress(this.state.addressFields);
            return address ? [address] : [];
        } else {
            return field.value || [];
        }
    }

    onChange(fieldIndex, value) {
        const addressFields = [...this.state.addressFields];

        const field = {
            ...addressFields[fieldIndex],
            value: value,
            ...this.hasError(addressFields[fieldIndex], value)
        };

        addressFields[fieldIndex] = field;
        this.props.onChange(addressFields);
    }

    onSelect(fieldIndex, valueIndex, value) {
        const addressFields = [...this.state.addressFields];

        const field = {
            ...addressFields[fieldIndex],
            value: value,
            ...this.hasError(addressFields[fieldIndex], value)
        };

        addressFields[fieldIndex] = field;

        switch (this.state.countryCode) {
            case "US":
                switch (field.id) {
                    case "addressLine1":
                        this.setUSAddress(addressFields, value);
                        break;
                    case "state":
                        const county = addressFields.find(f => f.id === "county");
                        county["value"] = "";
                        county["readOnly"] = false;
                        county["options"] = US_COUNTIES[value] || [];
                        break;
                }
                break;
        }

        if (field.id === "country") {
            const countryCode = this.getSelectValue(field.value, field.options);

            if (this.state.countryCode !== countryCode) {
                if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                    this.setState({
                        countryCode: countryCode
                    }, this.props.onChange(addressFields));
                } else {
                    const newAddressFields = deepClone(getAddressFields(countryCode, this.props.module));
    
                    const countryIndex = newAddressFields.findIndex(af => af.id === "country");
                    if (countryIndex !== -1) {
                        newAddressFields[countryIndex]["value"] = field.value;
                    }

                    this.setState({
                        countryCode: countryCode
                    }, this.props.onChange(newAddressFields));
                }
            }
        } else {
            this.props.onChange(addressFields)
        }
    }

    searchAddress(value) {
        return http.get(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.SEARCH_ADDRESS, {params: {searchText: value}});
    }

    setUSAddress(addressFields, address) {
        if (!Utility.isEmpty(address)) {
            addressFields.forEach((field) => {
                switch (field.id) {
                    case "addressLine1":
                        field.value = address.address1 ? address.address1 : address.label.split(",")[0];
                        break;
                    case "addressLine2":
                        field.value = address.addressLine2;
                        break;
                    case "zipCode":
                        field.value = address.zip;
                        break;
                    case "city":
                        field.value = address.city;
                        break;
                    case "state":
                        if (!address.state) {
                            field.readOnly = false;
                        } else {
                            field.value = this.getSelectLabel(address.state, field.options);
                            field.readOnly = address.country === "US";
                        }
                        break;
                    case "county":
                        if (!address.county) {
                            const state = addressFields.find(f => f.id === "state");
                            field.readOnly = false;
                            field.options = US_COUNTIES[state.value] || [];
                        } else {
                            field.value = address.county;
                            field.readOnly = true;
                        }
                        break;
                    case "country":
                        if (this.props.module !== ADDRESS_MODULE.COMPANY_DETAILS) {
                            switch (address.country) {
                                case "United States":
                                case "USA":
                                    address.country = "US";
                                    break;
                            }
    
                            field.value = this.getSelectLabel(address.country, field.options);
                        }
                        break;
                }
            });
        }
    }

    getUSAddress(addressFields) {
        let address = {};
        addressFields.forEach((field) => {
            switch (field.id) {
                case "addressLine1":
                    address.address1 = field.value;
                    break;
                case "addressLine2":
                    address.addressLine2 = field.value;
                    break;
                case "zipCode":
                    address.zip = field.value;
                    break;
                case "city":
                    address.city = field.value;
                    break;
                case "state":
                    address.state = this.getSelectValue(field.value, field.options);
                    break;
                case "county":
                    address.county = field.value;
                    break;
                case "country":
                    address.country = this.getSelectValue(field.value, field.options);
                    break;
            }
        });

        if (address.address1 || address.city || address.state || address.zip) {
            address.label = address.address1 || "";
            address.label += address.city ? `, ${address.city}` : "";
            address.label += address.state ? `, ${address.state}` : "";
            address.label += address.zip ? `, ${address.zip}` : "";
            address.label += ", USA";
        } else {
            address = null;
        }

        return address;
    }

    isRequired(validation) {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }

    getTooltip(tooltip) {
        return (
            <div className="position-absolute" style={{ height: "20px", width: "20px", right: "22px", top: "37px" }}>
                <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                <span data-tip={tooltip}>
                    <DKIcon className="ic-s-2" src={ic_info_warning} />
                </span>
            </div>
        )
    }

    hasError(field, value) {
        let error = {
            invalid: false,
            errorMsg: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    case "pattern":
                        if (value && !new RegExp(validation[1]).test(value)) {
                            error.invalid = true;
                            error.errorMsg = "Invalid " + field.title;
                        }
                        break;
                }
            });
        }

        return error;
    }

    showPatternError(validation, errorMsg, value) {
        if (value !== null && value !== undefined && String(value).length !== 0) {
            const pattern = validation.findIndex((v) => v[0] === "pattern") !== -1;

            return pattern && (
                <DKLabel
                    className="ml-xs fs-s text-red position-absolute"
                    style={{
                        top: "66px"
                    }}
                    text={errorMsg}
                />
            )
        }
    }

    buildForm() {
        const addressFields = this.state.addressFields.map((field, fieldIndex) => {
            switch (field.type) {
                case INPUT_TYPE.TEXT:
                    return (
                        <div className="mb-m web-width-50" key={field.id} >
                            <div className={`row p-h-l position-relative ${this.props.className} ${field.id}`}>
                                <DKInput
                                    title={field.title}
                                    type={field.type}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    value={field.value || ""}
                                    errorMessage={field.errorMsg}
                                    readOnly={field.readOnly || this.props.isReadOnly }
                                    required={this.isRequired(field.validation)}
                                    invalid={field.invalid}
                                    canValidate={field.invalid}
                                    tooltip = {{
                                        "content" : field.tooltip,
                                        // "style" : {maxWidth:"300px", backgroundColor:"#fef6e1"}
                                        "className" : "warning-tooltip-prop"

                                    }}
                                    onChange={(value) => {
                                        this.onChange(fieldIndex, value);
                                    }}
                                />
                                {/* {field.tooltip && this.getTooltip(field.tooltip)} */}
                                {field.invalid && this.showPatternError(field.validation, field.errorMsg, field.value)}
                            </div>
                        </div>
                    );
                    case INPUT_TYPE.DROPDOWN:
                        return (
                            <div key={field.id} className="mb-m web-width-50">
                                <div className={`row align-items-end p-h-l ${this.props.className} ${field.id}`}>
                                    <DKInput
                                        title={field.title}
                                        type={INPUT_TYPE.DROPDOWN}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        dropdownConfig={{
                                            allowSearch: true,
                                            data: field.options.map((item) => {
                                                return typeof item === "object" ? item.label : item;
                                            }),
                                            renderer: (index, item) => {
                                                return typeof item === "object" ? item.label : item;
                                            },
                                            onSelect: (index, value) => {
                                                if (typeof value === "object") {
                                                    this.onSelect(fieldIndex, index, value.label);
                                                } else {
                                                    this.onSelect(fieldIndex, index, value);
                                                }
                                            },
                                            debounceTime: 500
                                        }}
                                        value={field.value}
                                        errorMessage={field.errorMsg}
                                        readOnly={field.readOnly || this.props.isReadOnly}
                                        required={this.isRequired(field.validation)}
                                        invalid={field.invalid}
                                        canValidate={field.invalid}
                                        onChange={() => {}}
                                    />
                                    {field.tooltip && this.getTooltip(field.tooltip)}
                                </div>
                            </div>
                        );
                    case INPUT_TYPE.AUTOCOMPLETE:
                        return (
                            <div key={field.id} className="mb-m web-width-50">
                                <div className={`row align-items-end p-h-l ${this.props.className} ${field.id}`}>
                                    <DKInput
                                        title={field.title}
                                        type={INPUT_TYPE.DROPDOWN}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        dropdownConfig={{
                                            allowSearch: true,
                                            data: this.getAutocompleteData(field),
                                            searchApiConfig: {
                                                method: "GET",
                                                getUrl: (searchText) => {
                                                    return ApiConstants.URL.BASE
                                                        + ApiConstants.URL.COMPLIANCE.US.SEARCH_ADDRESS
                                                        + `?searchText=${searchText}&query=country=${COUNTRY.US}`
                                                },
                                                dataParser: (response) => response
                                            },
                                            renderer: (index, item) => item.label,
                                            onSelect: (index, value) => {
                                                this.onSelect(fieldIndex, index, value);
                                            }
                                        }}
                                        value={field.value}
                                        errorMessage={field.errorMsg}
                                        readOnly={field.readOnly || this.props.isReadOnly}
                                        required={this.isRequired(field.validation)}
                                        invalid={field.invalid}
                                        canValidate={field.invalid}
                                        onChange={() => {}}
                                    />
                                    {field.tooltip && this.getTooltip(field.tooltip)}
                                </div>
                            </div>
                        );
            }

        });

        return addressFields;
    }

    render() {
        return (
            <div className="parent-width" style={{ display: "flex", flexWrap: 'wrap' }}>
                {this.state.addressFields && this.buildForm()}
            </div>
        );
    }
}

export const ADDRESS_MODULE = {
    COMPANY_DETAILS: "COMPANY_DETAILS",
    EMPLOYEE_DETAILS: "EMPLOYEE_DETAILS",
    CONTRACTOR_DETAILS: "CONTRACTOR_DETAILS"
}

export const ADDRESS_MODULE_PERMISSION_MODULE_MAP = {
    [ADDRESS_MODULE.COMPANY_DETAILS]: MODULE.COMPANY_SETTINGS,
    [ADDRESS_MODULE.EMPLOYEE_DETAILS]: MODULE.EMPLOYEE,
    [ADDRESS_MODULE.CONTRACTOR_DETAILS]: MODULE.CONTRACTOR,
    [ADDRESS_MODULE.WORKPLACE]: 'WORKPLACE'
}
export function getAddressFieldValidation() {
    let address = TenantService.get(TENANT.ADDRESS);
    if(address && address.country) {
        switch(address.country) {
            case 'US':
            case 'IN':
                return ["required"];
            case 'MY':
                return [];
                
        }
    }
    return []
}

export function getAddressFields(countryCode, module) {
    const countries = Countries.map(c => {
        return {
            label: c.name,
            currencyCode: c.currencyCode,
            value: c.code,
            dial_code: c.dial_code,
            timezone: c.timezone
        }
    });

    let fields;

    let addressLine1 = {id: "addressLine1", title: "Address Line 1", type: INPUT_TYPE.TEXT, validation: [getAddressFieldValidation()]};
    let addressLine2 = {id: "addressLine2", title: "Address Line 2", type: INPUT_TYPE.TEXT};
    let zipCode = {id: "zipCode", title: "Zip Code", type: INPUT_TYPE.TEXT, validation: [getAddressFieldValidation()]};
    let city = {id: "city", title: "City", type: INPUT_TYPE.TEXT, validation: [getAddressFieldValidation()]};
    let state = {id: "state", title: "State", type: INPUT_TYPE.TEXT, validation: [getAddressFieldValidation()]};
    let county = {id: "county", title: "County", type: INPUT_TYPE.TEXT, validation: [getAddressFieldValidation()]}
    let country = {id: "country", title: "Country", type: INPUT_TYPE.DROPDOWN, options: countries, validation: [["required"]], readOnly: false };

    if (module === ADDRESS_MODULE.COMPANY_DETAILS) {
        
        const onboardingCountries = Countries.map(c => {
            return {
                label: c.name,
                currencyCode: c.currencyCode,
                value: c.code,
                dial_code: c.dial_code,
                timezone: c.timezone
            }
        });

        country = {id: "country", title: "Country", type: INPUT_TYPE.DROPDOWN, options: onboardingCountries, validation: [["required"]], readOnly: true };
    }

    fields = addCountrySpecificValidations(module, countryCode, [addressLine1, addressLine2, zipCode, city, state, county, country]);
    return fields;
}

export function addCountrySpecificValidations(module, countryCode, addressFields) {
    if (addressFields?.length === 0) {
        return [];
    }

    let fields = addressFields;

    let addressLine1;
    let addressLine2;
    let zipCode;
    let city;
    let state;
    let county;
    let country;

    addressFields.forEach((field) => {
        switch (field.id) {
			case "addressLine1":
				addressLine1 = { ...field, validation: [getAddressFieldValidation()] };
				break;
			case "addressLine2":
				addressLine2 = { ...field };
				break;
			case "zipCode":
				zipCode = { ...field, validation: [getAddressFieldValidation()] };
				break;
			case "city":
				city = { ...field, validation: [getAddressFieldValidation()] };
				break;
			case "state":
				state = { ...field, validation: [getAddressFieldValidation()] };
				break;
			case "county":
				county = { ...field, validation: [getAddressFieldValidation()] };
				break;
			case "country":
				country = { ...field, validation: [["required"]] };
				break;
			default:
				break;
		}
    });

    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
        if (Utility.isEmpty(county)) {
            county = { id: "county", title: "County", type: INPUT_TYPE.TEXT };
        }
		return [addressLine1, addressLine2, zipCode, city, state, county, country];
	}

    switch (countryCode) {
        case "IN":
            zipCode = {...zipCode, validation: [getAddressFieldValidation(), ["pattern", ZIPCODE_REGEX.IND]], tooltip: "Zipcode format (Example: 411006)"};
            state = {...state, type: INPUT_TYPE.DROPDOWN, options: IN_STATES};

            fields = [addressLine1, addressLine2, zipCode, city, state, country];
            break;
        case "US":
            addressLine1 = {...addressLine1, type: INPUT_TYPE.AUTOCOMPLETE, options: []};
            state = {...state, type: INPUT_TYPE.DROPDOWN, options: US_STATES};
            county = {...county, type: INPUT_TYPE.DROPDOWN, options: [], readOnly: true};

            fields = [addressLine1, addressLine2, zipCode, city, state, county, country];
            break;
        case COUNTRY.SG:
            addressLine1 = {...addressLine1, title:"Block/House No.", validation: []};
            addressLine2 = {...addressLine2, title:"Street Name"};
            zipCode = {...zipCode, validation: []};
            city = { ...city, validation: [], title: "Level No." };
            state = { ...state, validation: [], title: "Unit No." };

            fields = [addressLine1, addressLine2, zipCode, city, state, country];
            break;
        
        default:
            if (county && TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                fields = [addressLine1, addressLine2, zipCode, city, state, county, country];
            } else {
                fields = [addressLine1, addressLine2, zipCode, city, state, country];
            }
    }

    return fields;
}

export default Address;
